export default {
  Id: '',
  OrderSubscriptionId: '',
  OrderId: '',
  PolicyNumber: '',
  Order: {
    Id: '',
    Code: '',
    Amount: 0,
    Discount: 0,
    Status: '',
    StatusDetail: {
      Status: '',
      Description: '',
    },
    Items: [],
    Events: [],
    ExpiresAt: '',
    CreatedAt: '',
    UpdatedAt: '',
  },
  BillingCycle: 0,
  Amount: 0,
  SplitPayers: [],
  Status: '',
  StatusDetail: {
    Status: '',
    Description: '',
  },
  PaymentInstrument: {
    Id: '',
    Type: '',
    Card: {
      Id: '',
      Holder: {
        Name: '',
        TaxId: '',
      },
      Type: '',
      Brand: {
        Name: '',
        Code: '',
        LogoUrl: '',
      },
      Bin: '',
      LastFourDigits: '',
      ExpMonth: '',
      ExpYear: '',
      BillingAddress: {
        Id: '',
        ZipCode: '',
        Street: '',
        StreetNumber: '',
        Neighborhood: '',
        City: '',
        State: '',
        Country: '',
      },
      Principal: false,
      CreatedAt: '',
      UpdatedAt: '',
    },
    Status: '',
  },
  Events: [],
  DueDate: '',
  ProcessingDate: '',
  CreatedAt: '',
  UpdatedAt: '',
};
